// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"528f5f1b","519":"8992452e","648":"86b4c12a","792":"db400219","987":"59730dea"}[chunkId] + ".chunk.js";
};